import { NumberFilter } from "@react3l/advanced-filters";
import { getInitials } from "helpers/initials";
import { Dashboard, DashboardFilter } from "models/Dashboard";
import { EndUser } from "models/EndUser";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Observable } from "rxjs";
import { Link } from "react-router-dom";
import { END_USER_DETAIL_ROUTE } from "config/route-consts";

interface RecentEndUsersProps {
  getData: (filter?: DashboardFilter) => Observable<EndUser[]>;
  filter: Dashboard;
}

// Cắt số dòng để cột này kết thúc gần ngang cột biểu đồ bên cạnh.
const MAX_ITEMS = 6;


export default function RecentEndUsers(props: RecentEndUsersProps) {
  const { getData, filter } = props;

  const [model, setModel] = useState<EndUser[]>([]);

  // Đổi kỳ thì huỷ request của kỳ trước để danh sách không bị kỳ cũ đè.
  useEffect(() => {
    const subscription = getData({
      time: new NumberFilter({ equal: filter.time }),
      type: new NumberFilter({ equal: filter.type }),
      skip: 0,
      take: 1,
    }).subscribe((data: EndUser[]) => {
      setModel(data);
    });
    return () => subscription.unsubscribe();
  }, [filter, getData]);

  if (model.length === 0) {
    return <p className="dashboard-master__empty">Chưa có khách hàng mới trong kỳ này</p>;
  }

  return (
    <ul className="dashboard-master__end-users">
      {model.slice(0, MAX_ITEMS).map((item) => (
        <li key={item.id}>
          <Link className="dashboard-master__end-user" to={`${END_USER_DETAIL_ROUTE}?id=${item.id}`}>
            {item.avatar ? (
              <img className="dashboard-master__avatar" src={item.avatar} alt="" />
            ) : (
              <span className="dashboard-master__avatar dashboard-master__avatar--initials">
                {getInitials(item.displayName)}
              </span>
            )}
            <div className="dashboard-master__end-user-text">
              <div className="dashboard-master__end-user-name">{item.displayName}</div>
              <div className="dashboard-master__end-user-meta">
                {moment(item.createdAt).format("DD/MM/YYYY")}
              </div>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
}
